export default __webpack_public_path__ + "static/media/favicon.3bc34469.ico";